import { Box, useTheme } from '@mui/material';
import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { type DropdownListItem } from '@verantos-dev/shared-components';

import { useFilterBySection } from './useFilterBySection';
import { Dropdown } from '../../../../../wrapper-components/Dropdown/Dropdown';

export interface FilterBySectionProps {
  filterOptions: DropdownListItem[];
}

export const FilterBySection = ({ filterOptions }: FilterBySectionProps) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();

  const { filterBy, handleFilterByChange } = useFilterBySection();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(2) }}>
      <Typography variant="body1" sx={{ fontWeight: '500' }}>
        {formatMessage({ id: 'supervisorScreen.sidebar.viewOptions.filterBy.title' })}
      </Typography>
      <Dropdown
        id="supervisor-filter-by-dropdown"
        options={filterOptions}
        label={formatMessage({ id: 'supervisorScreen.sidebar.viewOptions.filterBy.label' })}
        width={288}
        sx={{ height: '56px' }}
        value={filterBy}
        onChange={(event) => handleFilterByChange(event.target.value as string)}
      />
    </Box>
  );
};
